import {register} from 'register-service-worker'

// Enregistre le service worker généré par Quasar (sw.js, issu de custom-service-worker.js).
// En mode PWA, c'est CE service worker qui reçoit les push — pas de SW standalone.
register(process.env.SERVICE_WORKER_FILE, {
  ready() {
    // SW prêt et actif.
  },
  registered(registration) {
    // Vérifie périodiquement une nouvelle version (toutes les heures).
    setInterval(() => registration.update(), 60 * 60 * 1000)
  },
  cached(/* registration */) {
  },
  updatefound(/* registration */) {
  },
  updated(/* registration */) {
    // La nouvelle version s'active et recharge la page d'elle-même (custom-service-worker.js) ;
    // la confirmation après rechargement est gérée par initGlobalEvents.
  },
  offline() {
  },
  error(err) {
    console.error('[pwa] Erreur enregistrement du service worker:', err)
  },
})
